<template>
  <div class="room-cbt-add-modal-component">
    <div class="room-cbt-add-modal flex flex-col">
      <div class="room-cbt-add-modal-header">
        <h6>문제집 상세 정보</h6>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="mt-6 flex flex-col gap-4 min-h-0 flex-1 overflow-hidden">
        <div class="flex flex-col gap-2">
          <div class="h-8 flex items-center">
            <p class="font-bold">제목</p>
          </div>
          <GrmTextField :value="selectedCBT.cbtTitle" size="xs" class="w-full" disabled />
        </div>
        <div class="flex flex-col gap-2">
          <div class="h-8 flex items-center">
            <p class="font-bold">문제집</p>
          </div>
          <GrmTextField :value="getRoomDocFile({ docId: selectedCBT.docId, roomGroupId: 'default' }).docName" size="xs" class="w-full" disabled />
        </div>
        <div class="flex flex-col gap-2 min-h-0 flex-1 overflow-y-auto">
          <div class="h-8 flex items-center gap-2">
            <p class="font-bold">문항 수 및 문항별 정답</p>
            <div class="flex items-center gap-1">
              <GrmTextField type="number" :value="selectedCBT.questionCnt" size="xs" class="w-16" disabled />
              <span class="text-sm">개</span>
            </div>
          </div>
          <div class="p-2 min-h-0 flex-1 overflow-y-auto relative">
            <div v-for="(cbtQuestion, i) in selectedCBT.questionList"
                 :key="cbtQuestion.questionId"
                 class="flex items-center gap-1"
                 :class="i !== 0 && (i+1) % cbtQuestion.answerList.length === 0 && (i+1) !== selectedCBT.questionCnt ? 'border-b pb-3 mb-3' : ''"
            >
              <span class="w-8 text-sm inline-block">{{ number(i+1) }}.</span>
              <div class="flex items-center gap-0.5">
                <div v-for="(answer, j) in cbtQuestion.answerList"
                        :key="answer.answerOrder"
                        class="w-4 h-4 rounded-full text-xs flex justify-center items-center"
                        :class="answer.correct ? 'bg-black' : 'border'"
                >{{ j+1 }}</div>
              </div>
              <div class="flex items-center text-sm">
                (<GrmTextField type="number" :value="cbtQuestion.questionScore" size="2xs" class="w-10" disabled />
                <span class="text-sm">점)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <div class="flex items-center gap-1">
            <div class="flex items-center">
              <GrmTextField type="number" textalign="right" size="xs" :min="0" :max="23" class="w-14 mr-1 flex" v-model="hours" />
              <p class="text-sm">{{ $t('common.hour') }}</p>
            </div>
            <div class="ml-3 flex items-center">
              <GrmTextField type="number" textalign="right" size="xs" :min="0" :max="59" class="w-14 mr-1 flex" v-model="minutes" />
              <p class="text-sm">{{ $t('common.minute') }}</p>
            </div>
          </div>
          <GrmBtn class="min-w-0 flex-1" @click="onStartCBT">전자문제집 출제</GrmBtn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";

export default {
  name: 'RoomCBTDetail',
  components: {
    GrmBtn,
    GrmTextField,
    GrmCloseBtn
  },
  data() {
    return {
      hours: 0,
      minutes: 30,
    }
  },
  computed: {
    ...mapState('cbt', [
      'selectedCBT'
    ]),
    ...mapGetters('doc', [
      'getRoomDocFile'
    ]),

    number() {
      return (i) => {
        if (i < 10) return `00${i}`
        if (i < 100) return `0${i}`
        return i
      }
    },
  },
  methods: {
    ...mapActions('room', [
      'changeRoomMode'
    ]),
    ...mapActions('cbt', [
      'startRoomCBT'
    ]),

    onClose() {
      this.$modal('RoomCBTDetail')
    },
    async onStartCBT() {
      if (this.hours === 0 && this.minutes === 0) {
        this.$alert(this.$t('roomCbt.alert.cbtTimeBlank'));
        return;
      }

      try {
        await this.startRoomCBT({
          duration: this.hours * 60 * 60 + this.minutes * 60,
          docId: this.selectedCBT.docId,
          cbtId: this.selectedCBT.cbtId,
        })

        this.$modal('RoomCBTDetail')
        this.$modal('RoomCBTModal')
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-add-modal-component {
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}
.room-cbt-add-modal {
  position: relative;
  width: 600px;
  height: 80vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.room-cbt-add-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>